import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowWallUp"><Path d="M16.75 11.25L12 6.5L7.25 11.25" stroke="currentColor" strokeLinecap="square"/><Path d="M12 21.5V7.25" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 2.5H4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowWallUp;
